var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M10.667 1.334V4M5.333 1.334V4M8.667 2.667H7.333c-2.514 0-3.77 0-4.552.78C2 4.23 2 5.487 2 8v1.333c0 2.514 0 3.771.781 4.552s2.038.781 4.552.781h1.334c2.514 0 3.77 0 4.552-.78.781-.782.781-2.039.781-4.553V8c0-2.514 0-3.771-.781-4.552s-2.038-.781-4.552-.781M2 6.667h12M7.333 9.334h3.334m-5.334 0h.006M8.667 12H5.333m5.334 0h-.006"
  })));
};
export default SvgCalendar;